import { createSlice } from '@reduxjs/toolkit';
import { IUser } from 'auth/types/User';

import * as reducers from 'store/reducers/authReducer';

const initialState = {
  isAuthenticated: false,
  user: null as IUser | null,
  clientDedupID: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers,
});

export const { login, logout, setIsUserAuthenticated, setUser, setStoreClientDedupID } =
  authSlice.actions;
export default authSlice.reducer;
